"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _formsV = _interopRequireWildcard(require("@kyruus/forms-v2"));
var _Actions = require("../../lib/constants/Actions");
var _States = require("../../lib/constants/States");
var _configUtils = require("../../lib/configUtils");
var _utils = require("../../lib/utils");
var _Recaptcha = require("../Recaptcha");
var _EhrPatientInfo = _interopRequireDefault(require("../EhrPatientInfo"));
var _ProxyBookingControls = _interopRequireDefault(require("../ProxyBookingControls/ProxyBookingControls"));
var _RegForm = require("../RegForm");
var _Banners = require("../Banners");
var _Loading = require("../Loading");
var _ApptTypeDisclaimer = _interopRequireDefault(require("./ApptTypeDisclaimer"));
var _EhrLoginLogout = require("./EhrLoginLogout");
var _constants = require("./constants");
var _Tracking = require("../../lib/constants/Tracking");
var _styles = require("./styles");
var _thirdPartyLogin = require("../../lib/constants/thirdPartyLogin");
var _thirdPartyLoginUtils = require("../../lib/thirdPartyLoginUtils");
var _intl = require("@kyruus/intl");
var _react3 = require("@emotion/react");
var _uiTheme = require("@kyruus/ui-theme");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const propTypes = {
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  /* eslint-disable react/forbid-prop-types */
  config: _propTypes.object.isRequired,
  intl: (0, _propTypes.shape)({
    locale: _propTypes.string.isRequired,
    formatMessage: _propTypes.func.isRequired
  }).isRequired,
  thirdPartyLoginProps: (0, _propTypes.shape)({
    type: (0, _propTypes.oneOf)(['mychart']).isRequired,
    isLoggedIn: _propTypes.bool.isRequired,
    login: (0, _propTypes.shape)({
      url: _propTypes.string,
      callback: _propTypes.func.isRequired
    }).isRequired,
    logout: (0, _propTypes.shape)({
      url: _propTypes.string,
      callback: _propTypes.func.isRequired
    }).isRequired,
    errors: (0, _propTypes.arrayOf)((0, _propTypes.oneOf)((0, _values.default)(_thirdPartyLogin.ERROR)))
  }),
  track: _propTypes.func.isRequired
};
function PatientInfo(_ref) {
  var _context4;
  let {
    config,
    service,
    intl,
    thirdPartyLoginProps = {},
    track
  } = _ref;
  const [state, send] = (0, _react2.useService)(service);
  const {
    provider,
    patientRegForm,
    insuranceOptions,
    appointmentQuery,
    selectedAppointment,
    updatedFields,
    csrfToken,
    ehr,
    ehrPatientList,
    selectedPatientIndex
  } = state.context;
  const theme = (0, _react3.useTheme)();
  const formRef = (0, _react.useRef)(null);
  const formBreakpoints = (0, _react.useMemo)(() => (0, _configUtils.isDirectBookRenderedInDrawer)(config) ? {
    screen_medium: (0, _uiTheme.fromTheme)('db_screen_medium')({
      theme
    })
  } : undefined, [config, theme]);
  (0, _react.useEffect)(() => {
    const inputId = 'session';
    if (formRef.current && formRef.current.querySelector && !formRef.current.querySelector(`#${inputId}`)) {
      // create new input element
      const hiddenInput = document.createElement('input');
      // set id, hidden, value, data-testid attrs
      hiddenInput.setAttribute('id', inputId);
      hiddenInput.setAttribute('hidden', '');
      hiddenInput.setAttribute('value', csrfToken);
      hiddenInput.setAttribute('data-testid', inputId);
      // append to the form (referenced by formRef)
      formRef.current.appendChild(hiddenInput);
    }
  }, [csrfToken, formRef]);
  const loginProps = (0, _react.useMemo)(() => (0, _thirdPartyLoginUtils.getLoginPropsWithIntl)({
    thirdPartyLoginProps,
    intl
  }), [intl, thirdPartyLoginProps]);
  if (state.matches(`${_States.patientForm}.${_States.fetchingPatientRegForm}`) || state.matches(`${_States.patientForm}.${_States.verifyingPatientRegForm}`)) {
    return /*#__PURE__*/_react.default.createElement(_Loading.LoadingPatientInfo, null);
  }
  if (state.matches(`${_States.patientForm}.${_States.error}`)) {
    track(_Tracking.userEvents.PATIENT_REG_FORM_FAIL);
    const phone = (0, _configUtils.shouldHideSchedulingHelpMessages)(config) ? '' : (0, _utils.getMainContactNumber)(provider);
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "PatientInfo"
    }, /*#__PURE__*/_react.default.createElement(_Banners.ErrorBookingBanner, {
      phone: phone
    }));
  }
  const {
    fields,
    disclaimer,
    addOns,
    isRequiredMarker,
    isNotRequiredMarker,
    apptTypeDisclaimers
  } = patientRegForm;
  const {
    editable_demographic_fields: editableDemographicFields = [],
    editable_demographic_fields_add_ons: editableDemographicFieldsAddOns,
    ehr_missing_demographics_banner_text: ehrMissingDemographicsBannerText
  } = config;
  if (state.matches(`${_States.ehrData}.${_States.ehrForm}`) || state.matches(`${_States.ehrData}.${_States.ehrFormRelatedFailed}`) || state.matches(`${_States.ehrData}.${_States.ehrFormNoDropdown}`)) {
    // if we have ehrPatientDemographics then it's the editableDemographicFields we need to update (EHR flow)
    (0, _forEach.default)(editableDemographicFields).call(editableDemographicFields, item => {
      var _context;
      if (item.path && (0, _includes.default)(_context = item.path).call(_context, 'plan_name')) {
        item.options = (0, _map.default)(insuranceOptions).call(insuranceOptions, name => ({
          label: name,
          value: name
        }));
      }
    });
  } else if (state.matches(`${_States.ehrData}.${_States.ehrSomebodyElseForm}`) || state.matches(`${_States.ehrData}.${_States.ehrSomebodyElseFormRelatedFailed}`) || state.matches(`${_States.ehrData}.${_States.ehrMainFailed}`) || state.matches(`${_States.ehrData}.${_States.ehrSubFailed}`) || state.matches(`${_States.ehrData}.${_States.freeform}`)) {
    (0, _forEach.default)(fields).call(fields, item => {
      var _context2;
      if (item.path && (0, _includes.default)(_context2 = item.path).call(_context2, 'plan_name')) {
        item.options = (0, _map.default)(insuranceOptions).call(insuranceOptions, name => ({
          label: name,
          value: name
        }));
      }
    });
  }
  const handleSubmit = (payload, done) => {
    send({
      type: _Actions.SET_PATIENT_REGISTRATION,
      data: {
        patientRegistration: payload
      }
    });
    done();
  };

  // handle submit for the EHR flow
  const ehrHandleSubmit = (payload, done) => {
    const demographics = ehrPatientList[selectedPatientIndex].demographics;
    send({
      type: _Actions.SET_PATIENT_REGISTRATION,
      data: {
        patientRegistration: {
          ...payload,
          address: {
            ...demographics.address,
            ...payload.address
          },
          patient: {
            ...demographics,
            ...payload.patient
          }
        }
      }
    });
    done();
  };

  // persists user-filled form data
  // (without saving "isRequired" errors, ie. errors with no value)
  const handleChange = _ref2 => {
    var _context3;
    let {
      updatedFields
    } = _ref2;
    (0, _forEach.default)(_context3 = (0, _keys.default)(updatedFields)).call(_context3, field => {
      if (!updatedFields[field].value) {
        updatedFields[field].errors = [];
      }
    });
    send({
      type: _Actions.FORM_CHANGE,
      data: {
        updatedFields
      }
    });
  };
  const handleTrack = (eventName, eventData) => {
    const {
      field_name,
      field_value
    } = eventData;
    const updatedEventData = {
      field_name,
      ...(field_value && (0, _includes.default)(_constants.REG_FORM_VALUE_WHITELIST).call(_constants.REG_FORM_VALUE_WHITELIST, field_name) ? {
        field_value
      } : {})
    };
    track(eventName.replace('user_action.', 'user_action.patient_reg_form.'), updatedEventData);
  };
  const handleCaptchaVerified = isCaptchaVerified => {
    send({
      type: _Actions.CAPTCHA_VERIFIED,
      data: isCaptchaVerified
    });
  };
  const handleCaptchaCancelled = () => {
    send(_Actions.CAPTCHA_CANCELLED);
  };
  const handleCaptchaError = () => {
    send(_Actions.CAPTCHA_ERROR);
  };
  const handleCaptchaReset = () => {
    send(_Actions.CAPTCHA_RESET);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loginProps && /*#__PURE__*/_react.default.createElement(_EhrLoginLogout.EhrLoginLogout, {
    intl: intl,
    loginProps: loginProps,
    callbackProps: {
      patientRel: appointmentQuery.patientRel,
      purpose: appointmentQuery.purpose.name,
      selectedAppointment
    },
    track: track
  }), ehr && /*#__PURE__*/_react.default.createElement(_ProxyBookingControls.default, {
    service: service
  }), (state.matches(`${_States.ehrData}.${_States.routing}`) || state.matches(`${_States.ehrData}.${_States.pendingEhrPatientDemographics}`)) && /*#__PURE__*/_react.default.createElement(_Loading.LoadingPatientInfo, null), (state.matches(`${_States.ehrData}.${_States.ehrForm}`) || state.matches(`${_States.ehrData}.${_States.ehrFormNoDropdown}`) || state.matches(`${_States.ehrData}.${_States.ehrFormRelatedFailed}`)) && /*#__PURE__*/_react.default.createElement(_EhrPatientInfo.default, {
    formBreakpoints: formBreakpoints,
    ehrPatientDemographics: ehrPatientList[selectedPatientIndex].demographics,
    bannerText: ehrMissingDemographicsBannerText,
    handleChange: handleChange,
    handleTrack: handleTrack,
    handleSubmit: ehrHandleSubmit,
    updatedFields: updatedFields,
    fields: editableDemographicFields,
    isRequiredMarker: isRequiredMarker,
    isNotRequiredMarker: isNotRequiredMarker,
    disclaimer: disclaimer,
    addOns: editableDemographicFieldsAddOns
  }), (0, _some.default)(_context4 = [`${_States.ehrData}.${_States.freeform}`, `${_States.ehrData}.${_States.ehrMainFailed}`, `${_States.ehrData}.${_States.ehrSubFailed}`, `${_States.ehrData}.${_States.ehrSomebodyElseForm}`, `${_States.ehrData}.${_States.ehrSomebodyElseFormRelatedFailed}`]).call(_context4, state.matches) &&
  /*#__PURE__*/
  /* we need to set a negative margin-top to offset the margin-top of the labels in the form's first row
  there is a ticket (https://kyruus.jira.com/browse/KENG-11185) to make a fix in forms-v2
  so that this negative margin-top won't be necessary */
  _react.default.createElement(_styles.NegativeMarginTopSpacingMediumWrapper, null, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "PatientInfo"
  }, /*#__PURE__*/_react.default.createElement(_ApptTypeDisclaimer.default, {
    provider: provider,
    apptTypeDisclaimers: apptTypeDisclaimers
  }), /*#__PURE__*/_react.default.createElement(_formsV.default, {
    breakpoints: formBreakpoints,
    onChange: handleChange,
    onTrack: handleTrack,
    onSubmit: handleSubmit,
    updatedFields: updatedFields,
    fields: fields,
    isRequiredMarker: isRequiredMarker,
    isNotRequiredMarker: isNotRequiredMarker,
    hideDefaultSubmit: true,
    formRef: formRef
  }, (0, _formsV.getAddOns)(addOns, handleTrack), /*#__PURE__*/_react.default.createElement(_formsV.Footer, null, _ref3 => {
    let {
      handleSubmit,
      handleTrack
    } = _ref3;
    return /*#__PURE__*/_react.default.createElement(_RegForm.RegFormFooterContent, {
      handleSubmit: handleSubmit,
      disclaimer: disclaimer,
      handleTrack: handleTrack
    });
  })))), state.matches(`${_States.patientForm}.${_States.verifyingCaptcha}`) && /*#__PURE__*/_react.default.createElement(_Recaptcha.RecaptchaModal, {
    onCancel: handleCaptchaCancelled,
    onVerified: handleCaptchaVerified,
    onError: handleCaptchaError,
    siteKey: config.recaptchaSiteKey
  }), state.matches(`${_States.patientForm}.${_States.verifyingCaptchaError}`) && /*#__PURE__*/_react.default.createElement(_Recaptcha.RecaptchaErrorModal, {
    onClose: handleCaptchaCancelled,
    onReset: handleCaptchaReset
  }));
}
PatientInfo.propTypes = propTypes;
var _default = exports.default = (0, _intl.injectIntl)(PatientInfo);
PatientInfo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PatientInfo",
  "props": {
    "thirdPartyLoginProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "type": {
            "name": "enum",
            "value": [{
              "value": "'mychart'",
              "computed": false
            }],
            "required": true
          },
          "isLoggedIn": {
            "name": "bool",
            "required": true
          },
          "login": {
            "name": "shape",
            "value": {
              "url": {
                "name": "string",
                "required": false
              },
              "callback": {
                "name": "func",
                "required": true
              }
            },
            "required": true
          },
          "logout": {
            "name": "shape",
            "value": {
              "url": {
                "name": "string",
                "required": false
              },
              "callback": {
                "name": "func",
                "required": true
              }
            },
            "required": true
          },
          "errors": {
            "name": "arrayOf",
            "value": {
              "name": "enum",
              "computed": true,
              "value": "Object.values(THIRD_PARTY_LOGIN_ERROR)"
            },
            "required": false
          }
        }
      },
      "required": false
    },
    "service": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "config": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "intl": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "locale": {
            "name": "string",
            "required": true
          },
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};